module.exports = __webpack_public_path__ + "img/cs5.89fba16c.png";